var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { InputMode } from './types';
import { getWeekNumber, getWeekDay, copyDate, DateAccuracy, normalize } from '@core/helper/date-time';
import ClockPartition from './partial/clock-partition.vue';
var TCDateTimeInput = /** @class */ (function (_super) {
    __extends(TCDateTimeInput, _super);
    function TCDateTimeInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.date = null;
        _this.InputMode = InputMode;
        _this.DateAccuracy = DateAccuracy;
        _this.isExpanded = false;
        _this.isManualEdit = false;
        _this.isDateLocked = false;
        _this.inputMode = InputMode.Date;
        //#endregion
        _this.isoDate = null;
        return _this;
    }
    Object.defineProperty(TCDateTimeInput.prototype, "areActionsEnabled", {
        get: function () {
            return !this.isManualEdit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "now", {
        get: function () {
            return normalize(new Date(), this.accuracy);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "placeholder", {
        get: function () {
            switch (this.accuracy) {
                case DateAccuracy.Date:
                    return 'yyyy-dd-mm';
                case DateAccuracy.DateTime:
                    return 'yyyy-dd-mm hh:mm';
                case DateAccuracy.DateTimeWithSeconds:
                    return 'yyyy-dd-mm hh:mm:ss';
                case DateAccuracy.Time:
                    return 'hh:MM';
                case DateAccuracy.TimeWithSeconds:
                    return 'hh:mm:ss';
            }
        },
        enumerable: false,
        configurable: true
    });
    TCDateTimeInput.prototype.selectDate = function (value, includeTime) {
        if (includeTime === void 0) { includeTime = false; }
        var newDate;
        if (value == null) {
            newDate = value;
        }
        else {
            newDate = new Date(this.date);
            newDate.setFullYear(value.getFullYear());
            newDate.setMonth(value.getMonth());
            newDate.setDate(value.getDate());
            if (includeTime) {
                if (this.accuracy == DateAccuracy.DateTime || this.accuracy == DateAccuracy.DateTimeWithSeconds) {
                    newDate.setHours(value.getHours());
                    newDate.setMinutes(value.getMinutes());
                }
                if (this.accuracy == DateAccuracy.DateTimeWithSeconds) {
                    newDate.setSeconds(value.getSeconds());
                }
            }
        }
        this.date = newDate;
    };
    TCDateTimeInput.prototype.isCurrent = function (date) {
        return this.date != null && date.getFullYear() == this.year && date.getMonth() == this.month && date.getDate() == this.day;
    };
    TCDateTimeInput.prototype.isToday = function (date) {
        var now = this.now;
        return date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate();
    };
    TCDateTimeInput.prototype.isWorkingDay = function (date) {
        return getWeekDay(date) < 5;
    };
    TCDateTimeInput.prototype.isHoliday = function (date) {
        return getWeekDay(date) == 6;
    };
    TCDateTimeInput.prototype.getValueFromDate = function (callback) {
        if (this.date == null)
            return '';
        return callback();
    };
    Object.defineProperty(TCDateTimeInput.prototype, "dateOrDefault", {
        get: function () {
            return this.date != null ? this.date : new Date();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedYear", {
        //#region Formatters
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () { return _this.date.getFullYear().toString(); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedMonthNumber", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                var month = _this.date.getMonth() + 1;
                return "".concat(month < 10 ? '0' : '').concat(month);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedDayNumber", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                var day = _this.date.getDate();
                return "".concat(day < 10 ? '0' : '').concat(day);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedDate", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                return "".concat(_this.formattedYear, "-").concat(_this.formattedMonthNumber, "-").concat(_this.formattedDayNumber);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedDateTime", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                return "".concat(_this.formattedDate, " ").concat(_this.formattedTime);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedDateTimeWithSeconds", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () { return "".concat(_this.formattedDate, " ").concat(_this.formattedTimeWithSeconds); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedTime", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                var hours = _this.date.getHours();
                var minutes = _this.date.getMinutes();
                return "".concat(hours < 10 ? '0' : '').concat(hours, ":").concat(minutes < 10 ? '0' : '').concat(minutes);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "formattedTimeWithSeconds", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                var seconds = _this.date.getSeconds();
                return "".concat(_this.formattedTime, ":").concat(seconds < 10 ? '0' : '').concat(seconds);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "isoDateFromDate", {
        get: function () {
            var _this = this;
            return this.getValueFromDate(function () {
                switch (_this.accuracy) {
                    case DateAccuracy.Date:
                        return _this.formattedDate;
                    case DateAccuracy.DateTime:
                        return _this.formattedDateTime;
                    case DateAccuracy.DateTimeWithSeconds:
                        return _this.formattedDateTimeWithSeconds;
                    case DateAccuracy.Time:
                        return _this.formattedTime;
                    case DateAccuracy.TimeWithSeconds:
                        return _this.formattedTimeWithSeconds;
                    default:
                        throw new Error("Unsupported accuracy ".concat(_this.accuracy));
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "year", {
        get: function () {
            return this.dateOrDefault.getFullYear();
        },
        set: function (value) {
            var date = new Date(this.date);
            date.setFullYear(value);
            this.date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "month", {
        get: function () {
            return this.dateOrDefault.getMonth();
        },
        set: function (value) {
            var date = new Date(this.date);
            date.setMonth(value);
            this.date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "day", {
        get: function () {
            return this.dateOrDefault.getDate();
        },
        set: function (value) {
            var date = new Date(this.date);
            date.setDate(value);
            this.date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "hours", {
        get: function () {
            return this.dateOrDefault.getHours();
        },
        set: function (value) {
            var previousDate = new Date(this.date);
            var date = new Date(this.date);
            date.setHours(value);
            if (this.isDateLocked) {
                copyDate(previousDate, date);
            }
            this.date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "minutes", {
        get: function () {
            return this.dateOrDefault.getMinutes();
        },
        set: function (value) {
            var previousDate = new Date(this.date);
            var date = new Date(this.date);
            date.setMinutes(value);
            if (this.isDateLocked) {
                copyDate(previousDate, date);
            }
            this.date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "seconds", {
        get: function () {
            return this.dateOrDefault.getSeconds();
        },
        set: function (value) {
            var previousDate = new Date(this.date);
            var date = new Date(this.date);
            date.setSeconds(value);
            if (this.isDateLocked) {
                copyDate(previousDate, date);
            }
            this.date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "days", {
        get: function () {
            // Months are zero-indexed. Adding 1 and getting the 0th day goes to the end of the previous month
            var count = new Date(this.year, this.month + 1, 0).getDate();
            var first = new Date(this.year, this.month, 1);
            var last = new Date(this.year, this.month, count);
            var days = [];
            // Not monday, include days from the previous month
            if (getWeekDay(first) != 0) {
                var previousMonth = new Date(this.year, this.month - 1);
                var previousMonthDayCount = new Date(this.year, this.month, 0).getDate();
                var offset = getWeekDay(first);
                var day = previousMonthDayCount - offset + 1;
                for (var i = 0; i < offset; i++) {
                    var date = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), day + i);
                    days.push({
                        date: date,
                        year: date.getFullYear(),
                        month: date.getMonth(),
                        day: date.getDate(),
                    });
                }
            }
            for (var i = 1; i <= count; i++) {
                var date = new Date(this.year, this.month, i);
                days.push({
                    date: date,
                    year: this.year,
                    month: this.month,
                    day: i
                });
            }
            // Not sunday, include days from the next month
            if (getWeekDay(last) != 6) {
                var nextMonth = new Date(this.year, this.month + 1);
                var nextMonthDayCount = new Date(this.year, this.month + 1, 0).getDate();
                var offset = 6 - getWeekDay(last);
                for (var i = 1; i <= offset; i++) {
                    var date = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), i);
                    days.push({
                        date: date,
                        year: date.getFullYear(),
                        month: date.getMonth(),
                        day: date.getDate()
                    });
                }
            }
            return days;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCDateTimeInput.prototype, "weeks", {
        get: function () {
            var days = this.days;
            var result = [];
            var chunk = 7;
            for (var i = 0; i < days.length; i += chunk) {
                var week = days.slice(i, i + chunk);
                if (i == 0) {
                    for (var _i = 0, week_1 = week; _i < week_1.length; _i++) {
                        var date = week_1[_i];
                        date.weekday = date.date.toLocaleString(document.documentElement.lang, {
                            weekday: 'short'
                        });
                    }
                }
                result.push({
                    number: getWeekNumber(new Date(days[i].year, days[i].month, days[i].day)),
                    days: week
                });
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    TCDateTimeInput.prototype.data = function () {
        var months = [];
        for (var i = 0; i < 12; i++) {
            var date = new Date();
            date.setMonth(i);
            months.push({
                number: i,
                label: date.toLocaleString(document.documentElement.lang, {
                    month: 'long'
                })
            });
        }
        return {
            months: months
        };
    };
    Object.defineProperty(TCDateTimeInput.prototype, "dateFromValue", {
        get: function () {
            var date = new Date(this.value);
            return !isNaN(date) && this.value != null ? date : null;
        },
        enumerable: false,
        configurable: true
    });
    TCDateTimeInput.prototype.setToCurrent = function () {
        var now = new Date();
        this.year = now.getFullYear();
        this.month = now.getMonth();
    };
    TCDateTimeInput.prototype.beforeMount = function () {
        this.date = this.dateFromValue;
        this.isoDate = this.isoDateFromDate;
    };
    TCDateTimeInput.prototype.mounted = function () {
        document.body.addEventListener('click', this.onBodyClick);
    };
    TCDateTimeInput.prototype.destroyed = function () {
        document.body.removeEventListener('click', this.onBodyClick);
    };
    TCDateTimeInput.prototype.onDateChanged = function () {
        this.isoDate = this.isoDateFromDate;
    };
    TCDateTimeInput.prototype.onValueChanged = function () {
        this.date = this.dateFromValue;
    };
    TCDateTimeInput.prototype.onIsoDateChanged = function () {
        if (!this.isManualEdit) {
            this.emitInputEvent();
        }
    };
    TCDateTimeInput.prototype.onBodyClick = function (e) {
        var target = e.target;
        // If the click occurred outside of the widget
        if (target != this.$el && !this.$el.contains(target)) {
            this.close();
        }
    };
    TCDateTimeInput.prototype.open = function () {
        this.isExpanded = true;
    };
    TCDateTimeInput.prototype.close = function () {
        if (this.isManualEdit) {
            this.toggleManualEdit();
        }
        this.isExpanded = false;
    };
    TCDateTimeInput.prototype.onInputFieldClicked = function () {
        if (!this.isManualEdit) {
            this.isExpanded ? this.close() : this.open();
        }
    };
    TCDateTimeInput.prototype.emitInputEvent = function () {
        this.$emit('input', this.isoDate);
    };
    TCDateTimeInput.prototype.toggleManualEdit = function () {
        this.isManualEdit = !this.isManualEdit;
        if (!this.isManualEdit) {
            var date = new Date(this.isoDate);
            if (isNaN(date)) {
                date = null;
            }
            this.selectDate(date, true);
            this.emitInputEvent();
        }
        else if (this.isManualEdit) {
            this.$refs.input.focus();
        }
        if (!this.isExpanded) {
            this.isExpanded = true;
        }
    };
    __decorate([
        Prop({ type: String, default: null })
    ], TCDateTimeInput.prototype, "value", void 0);
    __decorate([
        Prop({ type: String })
    ], TCDateTimeInput.prototype, "name", void 0);
    __decorate([
        Prop({ type: String, default: DateAccuracy.DateTime })
    ], TCDateTimeInput.prototype, "accuracy", void 0);
    __decorate([
        Watch('date')
    ], TCDateTimeInput.prototype, "onDateChanged", null);
    __decorate([
        Watch('value')
    ], TCDateTimeInput.prototype, "onValueChanged", null);
    __decorate([
        Watch('isoDate')
    ], TCDateTimeInput.prototype, "onIsoDateChanged", null);
    TCDateTimeInput = __decorate([
        Component({ components: { ClockPartition: ClockPartition } })
    ], TCDateTimeInput);
    return TCDateTimeInput;
}(Vue));
export default TCDateTimeInput;
